import React from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { Button, Container, FormDashboardInput } from '../../../components'
import service from '../../../features/individu/service'
import { errorHandler } from '../../../utils'

const memberOfLabel = {
  en: 'Members of',
  id: 'Member dari'
}

const DetailMember = () => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)
  const profile = useSelector(state => state.account.profile)
  const organization = useSelector(state => state.organizations.details_data)
  const [requesting, setRequesting] = React.useState(false)
  const { isLoggedIn, isOfficial } = useSelector(state => state.account)
  const canJoin = isLoggedIn && !isOfficial && !requesting

  const {
    name,
    members,
    total_member
  } = organization

  const handleJoin = () => {
    if(profile.userId && organization.id){
      setRequesting(true)
      service.join(profile.userId, organization.id)
      .then(res => {
        console.log(res)
        toast.success('Join request sent!')
      })
      .catch(err => {
        console.log({err})
        const msg = errorHandler(err)
        toast.error(msg)
      })
      .then(() => setRequesting(false))
    }

    if(!canJoin){
      toast.error('Join request already sent.')
    }
  }

  return (
    <Container className="lg:pt-16">
      <div className="flex flex-wrap justify-between items-center mb-12">
        <h2 className="text-2xl font-bold font-primary mb-4 md:mb-0">
          {memberOfLabel[language.name]} {name} ({total_member})
        </h2>
        <div>
          <Button
            className="uppercase text-sm px-6"
            thin
            onClick={handleJoin}
            disabled={!canJoin}
            isLoading={requesting}
          >
            {translation.ORGANIZATION.ask_to_join[language.name]}
          </Button>
        </div>
      </div>

      {
        (members && members.length > 0) &&
        <>
          <FormDashboardInput className="w-full mb-10" placeholder="Search member" />
          <div className="flex flex-wrap -mx-4 mb-24">
            {
              members.map(m => (
                <div className="w-1/2 lg:w-1/3 px-4" key={m.joinId || m.id}>
                  <div className="bg-white shadow rounded p-5 flex items-center">
                    <div className="mr-3 h-16 w-16 bg-no-repeat bg-center rounded-full shadow" style={{backgroundImage: `url('${m.image}')`, backgroundSize: '100%'}}>
                    </div>
                    <div>
                      <p className="font-bold text-lg mb-2">{m.name}</p>
                      <p className="font-light text-sm">{m.role}</p>
                    </div>
                  </div>
                </div>
              ))
            }
            {/* <div className="w-1/2 lg:w-1/3 px-4">
              <div className="bg-white shadow rounded p-5 flex items-center">
                <div className="mr-3 h-16 w-16 bg-gray-500 rounded-full">
                </div>
                <div>
                  <p className="font-bold text-lg mb-2">Mahmud Albizar</p>
                  <p className="font-light text-sm">Executive Organisasi</p>
                </div>
              </div>
            </div> */}
          </div>
        </>
      }
    </Container>
  )
}

export { DetailMember }
